import { type RecType } from '@/defs/rec'
import { useCard } from '@/hooks/useCard'

type Props = {
  enabled?: boolean
  rec?: RecType
}

export const useCardsRec = ({ enabled = true, rec }: Props) => {
  const { cardId, partnerRef } = rec || {}
  const { card, hasError, loading } = useCard({ cardId, enabled: enabled && !!cardId })
  const {
    card: cardPartner,
    hasError: hasErrorPartner,
    loading: loadingPartner,
  } = useCard({ cardId: partnerRef?.cardId, enabled: enabled && !!partnerRef })

  return {
    card,
    cardPartner,
    hasError: hasError || hasErrorPartner,
    loading: loading || (!!partnerRef && loadingPartner),
  }
}
